export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';
export const CAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || '';
export const MEDIA_URL = process.env.NEXT_PUBLIC_MEDIA_URL || '';
export const SITE_TITLE = process.env.NEXT_PUBLIC_SITE_TITLE || '';
